import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./store/authStore";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProductDetail from "./pages/ProductDetail";
import GhsDetail from "./pages/GhsDetail";
import SceneAnalysis from "./pages/SceneAnalysis";
import AiVisibility from "./pages/AiVisibility";
import Competitive from "./pages/Competitive";
import MaterialLibrary from "./pages/MaterialLibrary";
import DeliveryPlans from "./pages/DeliveryPlans";
import CopyLibrary from "./pages/CopyLibrary";
import Generation from "./pages/Generation";
import ExpenseStats from "./pages/ExpenseStats";
import PublishRecords from "./pages/PublishRecords";
import MediaInsight from "./pages/MediaInsight";
import MediaPool from "./pages/MediaPool";
import CitationSources from "./pages/CitationSources";
import IndexLedger from "./pages/IndexLedger";
import FactPacks from "./pages/FactPacks";
import OwnedAccounts from "./pages/OwnedAccounts";
import PlatformAccount from "./pages/PlatformAccount";
import SystemSettings from "./pages/SystemSettings";
import CompanyList from "./pages/CompanyList";
import CompanyDetail from "./pages/CompanyDetail";
import BrandList from "./pages/BrandList";
import BrandDetail from "./pages/BrandDetail";
import ProductList from "./pages/ProductList";
import DemoLayout from "./pages/demo/DemoLayout";
import DemoHome from "./pages/demo/DemoHome";
import Leads from "./pages/Leads";

/** 路由守卫：未登录时重定向到 /login。 */
function AuthGuard({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* 演示站：免登录（AuthGuard 之外），独立深色 DemoLayout，无侧边栏/顶部导航 */}
      <Route path="/demo" element={<DemoLayout />}>
        <Route index element={<DemoHome />} />
      </Route>
      <Route
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/generation" element={<Generation />} />
        <Route path="/companies" element={<CompanyList />} />
        <Route path="/companies/:companyId" element={<CompanyDetail />} />
        <Route path="/brands" element={<BrandList />} />
        <Route path="/brands/:brandId" element={<BrandDetail />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/products/:productId" element={<ProductDetail />} />
        <Route path="/products/:productId/fact-packs" element={<FactPacks />} />
        <Route path="/products/:productId/ghs" element={<GhsDetail />} />
        <Route path="/products/:productId/scenes" element={<SceneAnalysis />} />
        <Route path="/products/:productId/materials" element={<MaterialLibrary />} />
        <Route path="/ai-visibility" element={<AiVisibility />} />
        <Route path="/competitive" element={<Competitive />} />
        <Route path="/citation-sources" element={<CitationSources />} />
        <Route path="/index-ledger" element={<IndexLedger />} />
        <Route path="/delivery-plans" element={<DeliveryPlans />} />
        <Route path="/copy-library" element={<CopyLibrary />} />
        <Route path="/expenses" element={<ExpenseStats />} />
        <Route path="/publish-records" element={<PublishRecords />} />
        <Route path="/media-insight" element={<MediaInsight />} />
        <Route path="/media-pool" element={<MediaPool />} />
        <Route path="/owned-accounts" element={<OwnedAccounts />} />
        <Route path="/platform-account" element={<PlatformAccount />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/system-settings" element={<SystemSettings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
